import { ATT, card, emptyNote, sectionTitle } from "../components/ui.js";
import { BUGUN, DONEM } from "../config.js";
import { B, staffOf, stu } from "../domain/context.js";
import { avatar } from "../lib/avatar.js";
import { donemAdi, esc, fmtDate } from "../lib/fmt.js";
import { alabilecekler, teslimKisiti } from "../domain/students.js";
import {
  aylikOzet,
  binadakiler,
  donemGunleri,
  gunlukKayit,
  ogrenciKaydi,
} from "../domain/attendance.js";
import { state } from "../state.js";
import { closeModal } from "../components/studentModal.js";
import { rerender } from "../lib/rerender.js";
import { imzaAlaniMarkup, imzaAlaniniBagla } from "../components/imza.js";
import { imzaliMi, imzayiSakla } from "../lib/imza.js";
import { Yoklama } from "../repo/entities.js";

// ---------- YOKLAMA ----------
export function viewYoklama() {
  return state.attendanceTab === "aylik" ? aylikGorunum() : gunlukGorunum();
}

function sekmeler() {
  const sek = [
    { id: "gunluk", label: "Bugün" },
    { id: "aylik", label: `Aylık — ${donemAdi(DONEM)}` },
  ];
  const aktif = state.attendanceTab ?? "gunluk";
  return `
  <div class="flex items-center gap-1 rounded-xl bg-line/50 p-1 mb-4 w-fit">
    ${sek.map(s => `
      <button data-atttab="${s.id}"
        class="rounded-lg px-3 py-1.5 text-xs font-semibold transition ${aktif === s.id ? "bg-white shadow-card" : "text-inksoft hover:text-ink"}">
        ${s.label}
      </button>`).join("")}
  </div>`;
}

// ---------- Bugün ----------
function gunlukGorunum() {
  const t = B();
  const icerdekiler = binadakiler(t);

  return `
  ${sekmeler()}

  <div class="flex flex-wrap items-center gap-2 mb-4 text-xs">
    ${Object.entries(ATT).map(([k, v]) => `
      <span class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 font-semibold ${v.chip}">
        <span class="w-1.5 h-1.5 rounded-full ${v.dot}"></span>${v.label}:
        ${Object.values(t.attendance).filter(a => a.status === k).length}
      </span>`).join("")}
    <span class="text-inksoft ml-auto hidden sm:block">Durum için karta, çıkış için “Çıkış” düğmesine tıklayın</span>
  </div>

  ${tahliyeKarti(icerdekiler)}

  ${t.classes.map(c => {
    const kids = t.students.filter(s => s.classId === c.id);
    if (!kids.length) return "";
    return card(`
      <div class="p-5">
        <div class="flex items-center gap-2 mb-3">
          <span class="w-3 h-3 rounded-full" style="background:${c.color}"></span>
          <h2 class="font-display font-bold">${esc(c.name)}</h2>
          <span class="text-xs text-inksoft">· ${staffOf(c.teacherId)?.name ?? ""}</span>
        </div>
        <div class="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          ${kids.map(s => ogrenciKarti(t, s)).join("")}
        </div>
      </div>`, "mb-4");
  }).join("")}`;
}

function ogrenciKarti(t, s) {
  const a = t.attendance[s.id];
  const m = ATT[a.status];
  const icerde = a.status === "geldi" && !a.out;
  const kisit = teslimKisiti(s);

  const altSatir = a.status !== "geldi"
    ? (a.reason ? esc(a.reason) : "—")
    : a.out
      ? `Giriş ${a.in} · Çıkış ${a.out}${a.outBy ? ` — ${esc(a.outBy.name)}` : ""}`
      : `Giriş ${a.in} · okulda`;

  return `
  <div class="min-w-0 rounded-xl border ${kisit ? "border-coral/50" : "border-line"} bg-paper/50 hover:bg-paper transition">
    <button data-att="${s.id}" class="w-full min-w-0 flex items-center gap-3 px-3 py-2.5 text-left">
      ${avatar(s)}
      <span class="min-w-0 flex-1">
        <span class="flex items-center gap-1.5">
          <span class="text-sm font-semibold truncate">${esc(s.name)}</span>
          ${kisit ? `<span class="text-[10px] shrink-0" title="${esc(kisit)}">🔒</span>` : ""}
        </span>
        <span class="block text-[11px] text-inksoft truncate">${altSatir}</span>
      </span>
      <span class="text-[11px] font-bold rounded-full px-2.5 py-1 shrink-0 ${m.chip}">${m.label}</span>
    </button>

    ${icerde ? `
      <div class="px-3 pb-2.5 -mt-0.5">
        <button data-checkout="${s.id}"
          class="w-full rounded-lg bg-ink text-white text-[11px] font-semibold py-1.5 hover:bg-inksoft transition">
          Çıkış kaydet
        </button>
      </div>` : ""}

    ${a.out && a.outBy ? `
      <div class="px-3 pb-2.5 -mt-0.5 space-y-1.5">
        <div class="flex items-center gap-2">
          ${imzaliMi(a)
            ? `<button data-imza-goster="${s.id}"
                 class="flex-1 rounded-lg border border-teal/40 bg-teal-soft text-[11px] font-semibold py-1.5 text-teal hover:bg-teal/10 transition">
                 İmzalı — imzayı gör
               </button>`
            : `<span class="flex-1 rounded-lg border border-line bg-paper text-[11px] font-semibold py-1.5 text-inksoft text-center">
                 İmzasız teslim
               </span>`}
        </div>
        <button data-checkoutundo="${s.id}"
          class="w-full rounded-lg border border-line bg-white text-[11px] font-semibold py-1.5 text-inksoft hover:text-ink transition">
          Çıkışı geri al
        </button>
      </div>` : ""}
  </div>`;
}

// ---------- Tahliye listesi ----------
function tahliyeKarti(icerdekiler) {
  return card(`
    <div class="p-5">
      ${sectionTitle(
        "Şu An Binada",
        `<span class="text-[11px] font-bold rounded-full bg-teal-soft text-teal px-2.5 py-1">${icerdekiler.length} çocuk</span>`,
      )}
      <p class="text-[11px] text-inksoft mb-2">
        Tahliye anında bakılacak liste — giriş yapılmış ve çıkışı girilmemiş çocuklar.
      </p>
      ${icerdekiler.length
        ? `<div class="flex flex-wrap gap-1.5">
            ${icerdekiler.map(s => `
              <span data-student="${s.id}" class="inline-flex items-center gap-1.5 rounded-full bg-paper border border-line px-2 py-1 text-[11px] cursor-pointer hover:bg-line/40">
                ${avatar(s, "w-5 h-5")}<span class="font-semibold">${esc(s.name)}</span>
              </span>`).join("")}
          </div>`
        : emptyNote("Binada çocuk yok.")}
    </div>`, "mb-4");
}

// ---------- Aylık ----------
function aylikGorunum() {
  const t = B();
  const gunler = donemGunleri(DONEM);

  const satirlar = t.students
    .map(s => ({ s, o: aylikOzet(t, s, DONEM) }))
    .sort((a, b) => (a.o.devamOrani ?? 100) - (b.o.devamOrani ?? 100));

  const oranlar = satirlar.map(x => x.o.devamOrani).filter(x => x != null);
  const ortalama = oranlar.length
    ? Math.round(oranlar.reduce((a, b) => a + b, 0) / oranlar.length)
    : null;

  return `
  ${sekmeler()}

  <div class="grid gap-3 sm:gap-4 grid-cols-2 xl:grid-cols-4 mb-4">
    ${[
      { label: "Okul Günü", value: gunler.length, sub: donemAdi(DONEM), color: "sky" },
      { label: "Ortalama Devam", value: ortalama == null ? "—" : `%${ortalama}`, sub: "şube geneli", color: "teal" },
      { label: "Takip Gereken", value: satirlar.filter(x => x.o.devamOrani != null && x.o.devamOrani < 80).length, sub: "%80 altı devam", color: "coral" },
      { label: "Toplam Devamsızlık", value: satirlar.reduce((a, x) => a + x.o.gelmedi, 0), sub: "bildirimsiz gün", color: "sun" },
    ].map(s => card(`
      <div class="p-4">
        <div class="text-xs font-semibold text-inksoft">${s.label}</div>
        <div class="font-display font-extrabold text-3xl mt-1 text-${s.color}">${s.value}</div>
        <div class="text-[11px] text-inksoft/80 mt-0.5">${s.sub}</div>
      </div>`, "min-w-0")).join("")}
  </div>

  ${card(`
    <div class="p-5">
      ${sectionTitle("Devam Çizelgesi", `<span class="text-[11px] text-inksoft hidden sm:block">En düşük devam oranı üstte</span>`)}
      <div class="overflow-x-auto">
        <table class="w-full text-sm min-w-[560px]">
          <thead>
            <tr class="text-left text-[11px] uppercase tracking-wide text-inksoft border-b border-line">
              <th class="py-2.5 pr-4">Öğrenci</th>
              <th class="py-2.5 pr-3 text-center">Geldi</th>
              <th class="py-2.5 pr-3 text-center">İzinli</th>
              <th class="py-2.5 pr-3 text-center">Gelmedi</th>
              <th class="py-2.5 pr-4">Devam</th>
              <th class="py-2.5">Son 20 gün</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-line/70">
            ${satirlar.map(({ s, o }) => `
              <tr class="cursor-pointer hover:bg-paper/60" data-student="${s.id}">
                <td class="py-2.5 pr-4">
                  <span class="flex items-center gap-2 min-w-0">
                    ${avatar(s, "w-7 h-7")}
                    <span class="text-sm font-semibold truncate">${esc(s.name)}</span>
                  </span>
                </td>
                <td class="py-2.5 pr-3 text-center text-teal font-semibold">${o.geldi}</td>
                <td class="py-2.5 pr-3 text-center text-[#B07E14]">${o.izinli}</td>
                <td class="py-2.5 pr-3 text-center ${o.gelmedi ? "text-coral font-semibold" : "text-inksoft"}">${o.gelmedi}</td>
                <td class="py-2.5 pr-4 whitespace-nowrap">
                  ${o.devamOrani == null
                    ? `<span class="text-inksoft text-xs">kayıt yok</span>`
                    : `<span class="font-display font-bold ${o.devamOrani < 80 ? "text-coral" : "text-ink"}">%${o.devamOrani}</span>`}
                </td>
                <td class="py-2.5">${seritCiz(B(), s, o.gunler)}</td>
              </tr>`).join("")}
          </tbody>
        </table>
      </div>
    </div>`)}`;
}

// Son 20 okul gününü küçük bir şerit hâlinde çizer.
function seritCiz(t, student, gunler) {
  const renk = { geldi: "bg-teal", izinli: "bg-sun", gelmedi: "bg-coral" };
  return `<span class="flex gap-0.5">
    ${gunler.slice(-20).map(g => {
      const a = ogrenciKaydi(t, g, student.id);
      const c = a ? renk[a.status] : "bg-line";
      return `<span class="w-1.5 h-4 rounded-sm ${c}" title="${fmtDate(g)} · ${a ? ATT[a.status].label : "kayıt yok"}"></span>`;
    }).join("")}
  </span>`;
}

// ---------- Çıkış kaydı modalı ----------
// Çocuğu kimin aldığı seçilmeden çıkış kaydedilemez.
export function openCheckoutModal(studentId) {
  const s = stu(studentId);
  if (!s) return;
  const t = B();
  const a = gunlukKayit(t, BUGUN)?.[s.id];
  if (!a || a.status !== "geldi") return;

  const kisiler = alabilecekler(s);
  const kisit = teslimKisiti(s);

  document.getElementById("modalBox").innerHTML = `
    <div class="p-6">
      <div class="flex items-start gap-4">
        ${avatar(s, "w-12 h-12")}
        <div class="flex-1 min-w-0">
          <h2 class="font-display font-bold text-lg">${esc(s.name)} — Çıkış</h2>
          <p class="text-xs text-inksoft mt-0.5">Giriş ${esc(a.in ?? "—")} · çocuğu teslim alan kişiyi seçin</p>
        </div>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      ${kisit ? `
        <div class="rounded-xl border-2 border-coral bg-coral-soft p-3 mt-4">
          <div class="text-[11px] font-bold text-coral uppercase">Teslim kısıtı</div>
          <p class="text-xs font-semibold text-coral mt-1 leading-snug">${esc(kisit)}</p>
        </div>` : ""}

      <div class="mt-4 space-y-2">
        ${kisiler.map((k, i) => `
          <label class="flex items-center gap-3 rounded-xl border border-line px-3 py-2.5 cursor-pointer hover:bg-paper">
            <input type="radio" name="teslimAlan" value="${i}" class="w-4 h-4 accent-teal shrink-0">
            <span class="min-w-0 flex-1">
              <span class="block text-sm font-semibold truncate">${esc(k.name)}</span>
              <span class="block text-[11px] text-inksoft truncate">${esc(k.relation)}${k.idLast4 ? ` · kimlik ****${esc(k.idLast4)}` : ""} · ${esc(k.phone)}</span>
            </span>
          </label>`).join("")}
      </div>

      ${imzaAlaniMarkup()}

      <p class="text-[11px] text-inksoft mt-3">
        Listede olmayan biri geldiyse çıkış kaydedilmez — şube müdürüne başvurun.
        Seçilen kişi denetim izine yazılır.
      </p>

      <div class="flex items-center gap-2 mt-4">
        <button id="checkoutSave" data-student-id="${s.id}"
          class="rounded-xl bg-teal text-white text-sm font-semibold px-4 py-2 disabled:opacity-40 disabled:cursor-not-allowed" disabled>
          Çıkışı kaydet
        </button>
        <button id="checkoutCancel" class="rounded-xl border border-line bg-white text-sm font-semibold px-4 py-2">Vazgeç</button>
      </div>
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");

  // Modal render()'dan sonra açıldığı için olaylar burada bağlanır.
  const kaydet = document.getElementById("checkoutSave");
  modal.querySelectorAll('input[name="teslimAlan"]').forEach(el =>
    el.addEventListener("change", () => { kaydet.disabled = false; }));

  document.getElementById("modalClose").onclick = closeModal;
  document.getElementById("checkoutCancel").onclick = closeModal;

  const imzaAlani = imzaAlaniniBagla(modal);

  kaydet.addEventListener("click", async () => {
    const secim = modal.querySelector('input[name="teslimAlan"]:checked');
    if (!secim) return;
    const kisi = kisiler[Number(secim.value)];
    if (!kisi) return;

    // Yükleme ağ üzerinden; iki kez basılırsa iki çıkış kaydı düşer.
    kaydet.disabled = true;
    const saat = new Date().toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });

    let imza = null;
    const veri = imzaAlani.veri();
    if (veri) {
      try {
        imza = await imzayiSakla(state.tenantId, state.branchId, BUGUN, s.id, veri);
      } catch (e) {
        // İmza yüklenemezse çıkışı ENGELLEMİYORUZ. Çocuk kapıda
        // bekliyor; teslim alan kişi ve saat zaten kayda giriyor,
        // imza ek kanıt katmanı. Sorun denetim izine yazılıyor.
        console.warn("İmza yüklenemedi:", e?.message);
        imza = null;
      }
    }

    Yoklama.cikisKaydet(state.branchId, s, a, kisi, saat, imza);
    closeModal();
    rerender();
  });
}
